export type TiersNature = "prospect" | "client" | "revendeur" | "interne";

export interface MissionTypeRule {
  value: string;
  label: string;
  tiersNatures: TiersNature[];
  tiersRequis: boolean;
  robotsRequis: boolean;
  vehiculeRequis: boolean;
  champsSiteDemo: boolean;
  dateFinRequise: boolean;
  /** Affiche la section trajet (adresse départ/arrivée + estimation IGN) */
  avecDeplacement: boolean;
}

export const MISSION_TYPES: Record<string, MissionTypeRule> = {
  demonstration: {
    value: "demonstration", label: "Démonstration",
    tiersNatures: ["prospect", "client", "interne"], tiersRequis: true,
    robotsRequis: true, vehiculeRequis: true, champsSiteDemo: true, dateFinRequise: false,
    avecDeplacement: true,
  },
  cdc: {
    value: "cdc", label: "Cahier des charges / relevé",
    tiersNatures: ["prospect", "client", "interne"], tiersRequis: true,
    robotsRequis: false, vehiculeRequis: false, champsSiteDemo: false, dateFinRequise: false,
    avecDeplacement: true,
  },
  installation: {
    value: "installation", label: "Installation",
    tiersNatures: ["client", "interne"], tiersRequis: true,
    robotsRequis: true, vehiculeRequis: true, champsSiteDemo: false, dateFinRequise: false,
    avecDeplacement: true,
  },
  intervention_sav: {
    value: "intervention_sav", label: "Intervention SAV",
    tiersNatures: ["client", "revendeur", "interne"], tiersRequis: true,
    robotsRequis: true, vehiculeRequis: true, champsSiteDemo: false, dateFinRequise: false,
    avecDeplacement: true,
  },
  maintenance: {
    value: "maintenance", label: "Maintenance",
    tiersNatures: ["client", "interne"], tiersRequis: true,
    robotsRequis: true, vehiculeRequis: true, champsSiteDemo: false, dateFinRequise: false,
    avecDeplacement: true,
  },
  formation: {
    value: "formation", label: "Formation",
    tiersNatures: ["client", "revendeur", "interne"], tiersRequis: true,
    robotsRequis: false, vehiculeRequis: false, champsSiteDemo: false, dateFinRequise: false,
    avecDeplacement: false,
  },
  atelier: {
    value: "atelier", label: "Atelier",
    tiersNatures: [], tiersRequis: false,
    robotsRequis: true, vehiculeRequis: false, champsSiteDemo: false, dateFinRequise: false,
    avecDeplacement: false,
  },
  location: {
    value: "location", label: "Location",
    tiersNatures: ["revendeur", "client", "prospect", "interne"], tiersRequis: true,
    robotsRequis: true, vehiculeRequis: false, champsSiteDemo: false, dateFinRequise: true,
    avecDeplacement: true,
  },
  livraison: {
    value: "livraison", label: "Livraison",
    tiersNatures: ["client", "revendeur", "prospect", "interne"], tiersRequis: false,
    robotsRequis: false, vehiculeRequis: false, champsSiteDemo: false, dateFinRequise: false,
    avecDeplacement: true,
  },
  trajet: {
    value: "trajet", label: "Trajet",
    tiersNatures: ["client", "revendeur", "prospect", "interne"], tiersRequis: false,
    robotsRequis: false, vehiculeRequis: true, champsSiteDemo: false, dateFinRequise: false,
    avecDeplacement: true,
  },
  salon: {
    value: "salon", label: "Salon",
    tiersNatures: [], tiersRequis: false,
    robotsRequis: false, vehiculeRequis: false, champsSiteDemo: false, dateFinRequise: false,
    avecDeplacement: false,
  },
  salon_interne: {
    value: "salon_interne", label: "Salon interne",
    tiersNatures: [], tiersRequis: false,
    robotsRequis: false, vehiculeRequis: false, champsSiteDemo: false, dateFinRequise: false,
    avecDeplacement: false,
  },
  salon_partenaire: {
    value: "salon_partenaire", label: "Salon partenaire",
    tiersNatures: ["revendeur", "interne"], tiersRequis: false,
    robotsRequis: false, vehiculeRequis: false, champsSiteDemo: false, dateFinRequise: false,
    avecDeplacement: true,
  },
  prestation_evenement_client: {
    value: "prestation_evenement_client", label: "Prestation / événement client",
    tiersNatures: ["client", "prospect", "interne"], tiersRequis: false,
    robotsRequis: false, vehiculeRequis: false, champsSiteDemo: false, dateFinRequise: false,
    avecDeplacement: true,
  },
  bureau: {
    value: "bureau", label: "Bureau",
    tiersNatures: [], tiersRequis: false,
    robotsRequis: false, vehiculeRequis: false, champsSiteDemo: false, dateFinRequise: false,
    avecDeplacement: false,
  },
  organisation: {
    value: "organisation", label: "Organisation",
    tiersNatures: [], tiersRequis: false,
    robotsRequis: false, vehiculeRequis: false, champsSiteDemo: false, dateFinRequise: false,
    avecDeplacement: false,
  },
};
